import { httpClient } from '@/lib/api/httpClient';

export async function fetchHolidays() {
  return httpClient('/api/settings/holidays', { method: 'GET' });
}

export async function saveHoliday(payload) {
  return httpClient('/api/settings/holidays', {
    method: 'POST',
    body: JSON.stringify({ payload })
  });
}

export async function deleteHoliday(holidayId) {
  return httpClient(`/api/settings/holidays/${encodeURIComponent(holidayId)}`, { method: 'DELETE' });
}

export async function fetchProjects(params = {}) {
  const query = new URLSearchParams(params).toString();
  return httpClient(`/api/settings/projects${query ? `?${query}` : ''}`, { method: 'GET' });
}

export async function saveProject(payload) {
  return httpClient('/api/settings/projects', {
    method: 'POST',
    body: JSON.stringify({ payload })
  });
}

export async function deleteProject(projectId) {
  return httpClient(`/api/settings/projects/${encodeURIComponent(projectId)}`, { method: 'DELETE' });
}
